<template>
  <div>
    <v-btn
      small 
      class="mx-2 mb-1"
      color="secondary"
      @click="openApprovalStatusDialog()"
    >
      <v-icon small left>mdi-list-status</v-icon>
      Status da aprovação
    </v-btn>

    <v-dialog
      v-model="dialog"
      scrollable 
      persistent
      max-width="800px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>Status da Aprovação</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0 pt-3">
          <v-row>
            <v-col cols="12" class="py-0">
              <span>
                {{ $moment(one_done_form.done_at).format('DD/MM/YYYY, HH:mm') }} - Solicitação de Aprovação Enviada
              </span>
            </v-col>
            <v-col cols="12" class="py-0">
              <span>
                Quantidade de Aprovações Necessárias: {{ last_approvals.length }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>Última Atualização</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-for="(approval_config, idx) in last_approvals"
                      :idx="idx"
                      class="pb-1"
                    >
                      <span>{{ $moment(approval_config.updated_at).format('DD/MM/YYYY') }}</span>  
                      <span> Aprovação {{ idx+1 }}: </span>
                      <v-chip
                        class="white--text ml-1"
                        :color="approval_status_map[approval_config.approval_status].color"
                        small
                      >
                        {{ approval_status_map[approval_config.approval_status].text }}
                      </v-chip>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>Todos os Status</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-for="(round, idx) in approvation_rounds.filter((ar) => ar !== last_round)"
                      :idx="idx"
                    >
                      <div
                        v-for="(approval_config, idx) in approval_configs.filter((ac) => ac.approvation_round === round)"
                        :idx="idx"
                        class="pb-1"
                      >
                        <span>{{ $moment(approval_config.updated_at).format('DD/MM/YYYY') }}</span>  
                        <span> Aprovação {{ idx+1 }}: </span>
                        <v-chip
                          class="white--text ml-1"
                          :color="approval_status_map[approval_config.approval_status].color"
                          small
                        >
                          {{ approval_status_map[approval_config.approval_status].text }}
                        </v-chip>
                      </div>
                      <v-divider
                        class="my-3"
                      ></v-divider>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn
            color="error"
            @click="closeDialog()"
            text
          >
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: "ApprovalStatusDialog",
    data() {
      return {
        dialog: false,
        approval_status_map: {
          pending: {
            color: 'grey',
            text: 'Pendente'
          },
          rejected: {
            color: 'error',
            text: 'Reprovado'
          },
          approved: {
            color: 'success',
            text: 'Aprovado'
          }
        }
      }
    },
    methods: {
      closeDialog() {
        this.dialog = false;
      },
      openApprovalStatusDialog() {
        this.dialog = true;
      }
    },
    computed: {
      last_approvals() {
        if (this.last_round) {
          return this.approval_configs.filter((ac) => this.last_round === ac.approvation_round);
        }
      },
      last_round() {
        if (this.approvation_rounds) {
          let approvation_rounds = this.approval_configs.map((ac) => ac.approvation_round)
          return Math.max(...approvation_rounds);
        }
      },
      approvation_rounds() {
        if (this.approval_configs && this.approval_configs.length) {
          let all_rounds = this.approval_configs.map((ac) => ac.approvation_round);
          return [...new Set(all_rounds)];
        }
      },
      approval_configs() {
        if (this.one_done_form) {
          return this.one_done_form.approval_configs;
        }
      },
      ...mapState({
        one_done_form: state => state.DoneForm.oneDoneForm,
      })
    },
  }
</script>

<style lang="scss" scoped>

</style>